import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class OutsourceApiProvider extends BaseApi {
	async IsUnique(loCode: string, brandCode: string) {
		return this.fetch(`/${this.area}/${this.controller}/IsUnique?loCode=${loCode}&brandCode=${brandCode}`);
	}
}

export const apiProvider = new OutsourceApiProvider(DMS_MODULE, NAME);
